import { css } from 'styled-components';
import Roboto from './assets/Roboto/Roboto-Regular.ttf';
import RobotoLight from './assets/Roboto/Roboto-Light.ttf';
import RobotoSlab from './assets/Roboto_Slab/RobotoSlab-Regular.ttf';

export const toastStyles = css`
  .Toastify__toast {
    min-height: 48px !important;
    font-size: 12px;
    border-radius: 3px;
    box-shadow: 0 0 6px 0 rgba(77, 83, 90, 0.5);

    .Toastify__close-button {
      font-size: 8px;
      color: #bbbbbb;

      &:hover {
        color: #000000;
      }
    }

    &.Toastify__toast--error {
      background-color: #f65556;
    }

    &.Toastify__toast--info {
      color: #4b4e55;
      background-color: #ffffff;
    }
  }
`;

const globalStyles = css`
  @font-face {
    font-family: 'Roboto';
    src: url('${RobotoLight}') format('truetype');
    font-style: normal;
    font-weight: 300;
    font-display: swap;
  }
  @font-face {
    font-family: 'Roboto';
    src: url('${Roboto}') format('truetype');
    font-style: normal;
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: 'RobotoSlab';
    src: url('${RobotoSlab}') format('truetype');
    font-display: swap;
  }

  html {
    height: 100%;
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-x: hidden;
    font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: normal !important;
    
    &.noscroll {
      overflow: hidden;
    }
  }

  .react-app {
    height: 100%;
     > div {
      height: 100%;
    }
  }

  .react-app-container {
    margin-top: 59px;
    flex: 1 1 auto;

    > div {
      height: 100%;
    }
  }

  .sidebar + .react-app-container,
  .custom-sidebar-container + .react-app-container {
    padding-left: 54px;
  }

  .sidebar + .react-app,
  .custom-sidebar-container + .react-app {
    padding-left: 54px;
    header {
      margin-left: -54px;
      width: 100vw;
      max-width: none;
    }
  }

  .root {
    height: 100%;
    
    > div {
      height: 100%;
    }
  }

  .slider-control-bottomcenter {
    position: relative !important;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    z-index: 100;
  }

  ${toastStyles};
  


  ::-ms-clear {
    display: none;
  }
`;

export default globalStyles;
